import { SOCIAL_PROFILE_NAMES } from "./historyProfileNames";

/** Social/personal sections that must each have at least one saved entry. */
export const REQUIRED_SOCIAL_PROFILES = [
  "Smoking Profile",
  "Drinking Profile",
  "Sexual Activity Profile",
];

const DRUG_PROFILE_NAMES = new Set([
  "Drug Use Profile",
  "Illicit Drug Use Profile",
]);

export const isPatientFemale = (sex) => {
  const normalized = String(sex || "").trim().toLowerCase();
  return normalized === "female" || normalized === "f";
};

export const isPatientMale = (sex) => {
  const normalized = String(sex || "").trim().toLowerCase();
  return normalized === "male" || normalized === "m";
};

const collectSocialProfileNames = (medSummaryData, socialSummaryData) => {
  const names = new Set();
  const ingest = (rows) => {
    (rows || []).forEach((row) => {
      if (!row?.name) return;
      if (SOCIAL_PROFILE_NAMES.has(row.name) || DRUG_PROFILE_NAMES.has(row.name)) {
        names.add(row.name);
      }
    });
  };
  ingest(socialSummaryData);
  ingest(medSummaryData);
  return names;
};

export const hasRequiredSocialHistory = (medSummaryData, socialSummaryData) => {
  const names = collectSocialProfileNames(medSummaryData, socialSummaryData);
  const hasDrug = [...DRUG_PROFILE_NAMES].some((profileName) =>
    names.has(profileName)
  );
  const hasRest = REQUIRED_SOCIAL_PROFILES.every((profileName) =>
    names.has(profileName)
  );
  return hasDrug && hasRest;
};

export const hasPastMedicalHistory = (pastMedRows) =>
  (pastMedRows || []).length > 0;

export const hasFamilyPastMedicalHistory = (
  medSummaryData,
  heredofamilialRows
) => {
  if ((heredofamilialRows || []).length > 0) return true;
  return (medSummaryData || []).some(
    (row) => row.name === "Family Past Medical History Profile"
  );
};

export const hasObGyneHistory = (medSummaryData, obgyneRows) => {
  if ((obgyneRows || []).length > 0) return true;
  return (medSummaryData || []).some((row) => row.name === "OB-Gyne History");
};

export const areHistoryRequirementsMet = ({
  sex,
  medSummaryData,
  socialSummaryData,
  pastMedRows,
  heredofamilialRows,
  obgyneRows,
}) => {
  if (!hasRequiredSocialHistory(medSummaryData, socialSummaryData)) {
    return false;
  }
  if (!hasPastMedicalHistory(pastMedRows)) {
    return false;
  }
  if (!hasFamilyPastMedicalHistory(medSummaryData, heredofamilialRows)) {
    return false;
  }
  if (isPatientFemale(sex) && !hasObGyneHistory(medSummaryData, obgyneRows)) {
    return false;
  }
  return true;
};
